"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getQueryEngineConfig = void 0;
const Postgres = __importStar(require("./postgres"));
const Redshift = __importStar(require("./redshift"));
const BigQuery = __importStar(require("./bigquery"));
const MicrosoftSQLServer = __importStar(require("./microsoftSQLServer"));
const MariaDb = __importStar(require("./mariadb"));
const Snowflake = __importStar(require("./snowflake"));
const MySQL = __importStar(require("./mysql"));
const localJS_1 = require("./localJS");
const getQueryEngineConfig = (client) => {
    switch (client) {
        case 'js':
            return localJS_1.localQueryEngineConfig;
        case 'postgres':
            return Postgres.queryEngineConfig();
        case 'redshift':
            return Redshift.queryEngineConfig();
        case 'bigquery':
            return BigQuery.queryEngineConfig();
        case 'mariadb':
            return MariaDb.queryEngineConfig();
        case 'snowflake':
            return Snowflake.queryEngineConfig();
        case 'mysql':
            return MySQL.queryEngineConfig();
        case 'microsoftSQLServer':
            return MicrosoftSQLServer.queryEngineConfig();
        case 'SQLite':
            throw 'SQLite not support via the query engine';
    }
};
exports.getQueryEngineConfig = getQueryEngineConfig;
